var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v("如果您未能接受到邮件，建议您：")]),_c('span',[_vm._v("1）查看被拦截邮件或垃圾邮箱")]),_c('span',[_vm._v("2）更换其他电子邮箱尝试")]),_c('span',[_vm._v("3）联系我们（contact@51xueshuo.com）")])])
}]

export { render, staticRenderFns }